(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["doubale-side-text"] && !Shopify.designMode) return;
  try {
    
    $("p:contains('<breakline>')").addClass("hidden");
  
 $(document).ready(function() {
    $("p:contains('<breakline>')").addClass("hidden");
  });

  } catch(e) { console.error(e); }
})();
})();
